import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "about",
  "data-aos": "fade-up"
}
const _hoisted_2 = { class: "container py-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "text-color1 text-center" }
const _hoisted_6 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-9 w-10 w-md-5 border-color1" }, null, -1)
const _hoisted_8 = { class: "text-verydarkblue mx-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-9 w-10 w-md-5 border-color1" }, null, -1)
const _hoisted_10 = {
  class: "d-flex justify-content-center align-items-center my-3",
  "data-aos": "fade-up"
}
const _hoisted_11 = { class: "text-center text-silver lh-2rem" }
const _hoisted_12 = {
  class: "row bg-verylightgray px-4 py-4",
  "data-aos": "fade-up"
}
const _hoisted_13 = {
  class: "col-12 col-md-6",
  "data-aos": "slide-left"
}
const _hoisted_14 = { class: "col-12 col-md-5 px-md-4" }
const _hoisted_15 = { class: "text-start text-verydarkblue mt-5" }
const _hoisted_16 = { class: "text-grey lh-2rem text-justify" }

import { useGlobalStore, useConfigStore } from '@/stores';
import aboutImage from '@/assets/about.jpg';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationDescription',
  setup(__props) {

const globalStore = useGlobalStore();
const configStore = useConfigStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(configStore).stringLang(
                _unref(globalStore).organization.nameAr,
                _unref(globalStore).organization.nameEn
              )), 1),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t('GET_TO_KNOW_US')), 1),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(configStore).stringLang(
                  _unref(globalStore).organization.visionAr,
                  _unref(globalStore).organization.visionEn
                )), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "image-container rounded-3",
            style: _normalizeStyle(`background-image: url(${_unref(aboutImage)})`)
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("h4", _hoisted_15, _toDisplayString(_unref(configStore).stringLang(
                _unref(globalStore).organization.nameAr,
                _unref(globalStore).organization.nameEn
              )), 1),
          _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(configStore).stringLang(
                _unref(globalStore).organization.descriptionAr,
                _unref(globalStore).organization.descriptionEn
              )), 1)
        ])
      ])
    ])
  ]))
}
}

})